import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationSearchResults, WebsocketNotification } from 'src/app/shared/models/notification';
import { ApiBaseService } from './api/api-base.service';
import { NotificationsApiService } from './api/notifications-api.service';
import { AuthService } from './auth/auth.service';
import { ErrorService } from './error/error.service';
import { WebsocketService } from './websocket.service';


@Injectable({
  providedIn: 'root'
})
export class NotificationService extends ApiBaseService {
  constructor(
    public http: HttpClient,
    public errorService: ErrorService,
    protected spinner: NgxSpinnerService,
    protected authService: AuthService,
    protected wsService: WebsocketService,
    protected apiService: NotificationsApiService) {
    super(spinner, errorService);
  }

  public listen() {
    if (this.authService.isAuthenticated()) {
      return this.wsService.connect(`notify`)
        .pipe(map(this.deserializeAs(WebsocketNotification)));
    }
    this.authService.logout(true);
  }

  public notifications(): Observable<NotificationSearchResults> {
    return this.apiService.getUserNotifications();
  }

  public markNotificationAsRead(id: number): Observable<any> {
    return this.apiService.markNotificationAsRead(id);
  }
}